import { styled } from 'next-yak';
import { Text } from 'components';
import Image from 'next/image';

// const HEADER_HEIGHT = 72;
// const FOOTER_HEIGHT_MOBILE = 98;
// const FOOTER_HEIGHT_DESKTOP = 120;

export const Layout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;

  background-color: var(--white);
  padding: var(--layout-padding-side);

  height: calc(100vh - 17rem);
  width: 100%;

  @media (min-width: 767px) {
    height: calc(100vh - 19.2rem);
  }
`;

export const Illustration = styled(Image)`
  max-width: 280px;

  height: auto;

  object-fit: contain;

  @media (min-width: 767px) {
    max-width: 350px;
  }
`;

export const StyledText = styled(Text)`
  font-size: 1.8rem;
  line-height: 1.2;
  text-align: center;

  @media (min-width: 450px) {
    font-size: 2rem;
  }

  @media (min-width: 767px) {
    margin: 0 auto;
    max-width: 80%;
  }

  @media (min-width: 1200px) {
    font-size: 2.5rem;
    max-width: 60%;
  }
`;

export const StyledTitle = styled.div`
  margin: 2rem 0;
  text-align: center;

  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;
  text-transform: uppercase;

  @media (min-width: 330px) {
    font-size: 3rem;
  }

  @media (min-width: 450px) {
    font-size: 5rem;
  }
`;